"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID = exports.SPL_ACCOUNT_COMPRESSION_ADDRESS = void 0;
__exportStar(require("./generated"), exports);
var generated_1 = require("./generated");
Object.defineProperty(exports, "SPL_ACCOUNT_COMPRESSION_ADDRESS", { enumerable: true, get: function () { return generated_1.PROGRAM_ADDRESS; } });
Object.defineProperty(exports, "SPL_ACCOUNT_COMPRESSION_PROGRAM_ID", { enumerable: true, get: function () { return generated_1.PROGRAM_ID; } });
__exportStar(require("./instructions"), exports);
__exportStar(require("./accounts"), exports);
__exportStar(require("./events"), exports);
__exportStar(require("./constants"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./merkle-tree"), exports);
//# sourceMappingURL=index.js.map